import type { VetRxDrawerTypes } from '../ui/types';

export const getVetRxDrawerHeader = (type: VetRxDrawerTypes): string => {
    switch (type) {
        case 'cold':
            return 'Cold item info';
        case 'rx_med':
            return 'Prescription info required';
        case 'rx_food':
            return 'Vet authorization required';
        default:
            return '';
    }
};
